import { Images } from 'lucide-react'

interface ImageLibraryButtonProps {
    onClick: () => void
    disabled?: boolean
}

export function ImageLibraryButton({ onClick, disabled = false }: ImageLibraryButtonProps) {
    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className="
                flex items-center justify-center gap-2
                px-4 py-2 rounded-lg
                bg-gray-100 dark:bg-gray-800
                text-gray-700 dark:text-gray-300
                text-sm font-medium
                hover:bg-gray-200 dark:hover:bg-gray-700
                transition-colors duration-200
                disabled:opacity-50 disabled:cursor-not-allowed
                focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2
            "
            aria-label="Escolher da biblioteca"
        >
            <Images className="w-4 h-4" />
            <span>Biblioteca</span>
        </button>
    )
}
